export enum CmsContentItemTypes {
  CmsMarkdown = "CmsMarkdown",
  CmsImage = "CmsImage"
}

export type CmsContentItem = {
  id: string;
  type: CmsContentItemTypes;
  parameters?: CmsItemParameters;
};

export type CmsSlotGridParameters = CmsSlotParametersBase & {
  justifyContent: string;
  columns?: number;
  columnsDesktop?: number;
};
export type CmsSlotPageParameters = CmsSlotParametersBase & {
  patreonOnly: boolean;
};
type CmsSlotParametersBase = { card: boolean; hideMobile?: boolean; hideDesktop?: boolean };
export type CmsSlotParameters = CmsSlotParametersBase | CmsSlotGridParameters | CmsSlotPageParameters;

export type CmsItemParametersBase = {
  hideMobile?: boolean;
  hideDesktop?: boolean;
};

export type CmsItemGridParameters = CmsItemParametersBase & {
  size: number;
};

export type CmsItemParameters = CmsItemParametersBase | CmsItemGridParameters;

export enum CmsSlotType {
  Banner = 0,
  Grid = 1,
  Page = 2,
  Stack = 3
}
